<template>
<Loader :isLoading="isLoading"/>
  <div class="container-fluid">
    <form class="row g-3" @submit.prevent="preUpdateUser" v-show="!isEdit && !isLoading">
      <div class="col-12 col-sm-4">
        <div class="mt-4 card card-body">
                    <div class="row text-center">
            <div class="col-12">
              <label>Imagen de perfil</label>
            </div>
           <div class="col-12">
                <img
                  class="mt-3 shadow-lg img-fluid border-radius-lg w-100 h-auto"
                  id="image-profile-edit"
                  alt="profile-image"
                />
                
                <input type="file" id="img-input" class="d-none" :class="{ 'is-invalid': errors.profile, 'is-valid': errors.profile === null }" @change="handleFileChange" accept=".png, .jpg, .jpeg" > 
                <div class="invalid-feedback" v-if="errors.profile">
                          {{ errors.profile }}
                </div>
              </div>
              <div class="mt-4 col-12">
                  <button
                    class="mb-0 btn bg-gradient-danger btn-sm me-2"
                    type="button"
                    name="button"
                    @click="openExplorer"
                  >
                    Editar
                  </button>

                  <button 
                  type="button"
                  class="mb-0 btn btn-sm bg-gradient-dark"
                  title="Guardar"
                  @click="saveImage()"
                  >
                    Guardar
                  </button>
              </div>
          </div>   
        </div>
      </div>
      <div class="mx-auto col-sm-8 col-12">
        <div class="mt-4 card card-body">
          <h6 class="mb-0">Información básica</h6>
          <hr class="my-3 horizontal dark" />
          <div class="row">
            <div class="col-12 col-sm-6 col-lg-4 mb-3">
              <label>Nombre</label>
              <input
                id="name"
                type="text"
                v-model.trim="user.name"
                placeholder="eg. Michael"
                name="name"
                class="form-control"
                :class="{ 'is-invalid': errors.name, 'is-valid': errors.name === null }"
              />
              <div class="invalid-feedback" v-if="errors.name">
                  {{ errors.name }}
              </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-4  mb-3">
              <label>Apellido Paterno</label>
              <input
                id="lastname"
                type="text"
                placeholder="eg. Jackson"
                name="lastname"
                v-model.trim="user.lastname"
                class="form-control"
               :class="{ 'is-invalid': errors.lastname, 'is-valid': errors.lastname === null }"
              />
              <div class="invalid-feedback" v-if="errors.lastname">
                  {{ errors.lastname }}
              </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-4  mb-3">
              <label>Apellido Materno</label>
              <input
                id="surname"
                type="text"
                placeholder="eg. Smith"
                name="surname"
                v-model.trim="user.surname"
                class="form-control"
              :class="{ 'is-invalid': errors.surname, 'is-valid': errors.surname === null }"
              />
              <div class="invalid-feedback" v-if="errors.surname">
                  {{ errors.surname }}
              </div>
            </div>

            <div class="col-12 col-sm-6 col-lg-4 mb-3">
              <label>Sexo</label>
              <select
                id="sex-select"
                class="form-control"
                name="sex-select"
                v-model="user.sex"
                :class="{ 'is-invalid': errors.sex, 'is-valid': errors.sex === null }"
              >
                <option value="" selected disabled>Selecciona una opción...</option>
                <option value="1" >Masculino</option>
                <option value="2">Femenino</option>
              </select>
              <div class="invalid-feedback" v-if="errors.sex">
                  {{ errors.sex }}
              </div>
            </div>

            <div class="col-12 col-sm-6 col-lg-4 mb-3">
              <label>Fecha de nacimiento</label>
             <input
                id="birthday"
                type="date"
                name="birthday"
                v-model="user.birthday"
                class="form-control"
              :class="{ 'is-invalid': errors.birthday, 'is-valid': errors.birthday === null }"
              />
              <div class="invalid-feedback" v-if="errors.birthday">
                  {{ errors.birthday }}
              </div>
            </div>

            <div class="col-12 col-sm-6 col-lg-4 mb-3">
              <label>Estado de residencia</label>
              <select
                id="state-select"
                class="form-control"
                name="state-select"
                v-model="user.state"
                :class="{ 'is-invalid': errors.state, 'is-valid': errors.state === null }"
              >
                <option value="" selected disabled>Selecciona una opción...</option>
                <option v-for="({id, name}, index) in states" :key="index" :value="id" >{{name}}</option>
              </select>
              <div class="invalid-feedback" v-if="errors.state">
                  {{ errors.state }}
              </div>
            </div>

              <div class="col-12 col-sm-6 col-lg-4 mb-3">
              <label>Télefono(<span class="text-danger">*</span>)</label>
             <input
                id="cellphone"
                type="number"
                placeholder="eg. 76568788787"
                name="cellphone"
                v-model="user.cellphone"
                class="form-control"
               :class="{ 'is-invalid': errors.cellphone, 'is-valid': errors.cellphone === null }"
              />
              <div class="invalid-feedback" v-if="errors.cellphone">
                  {{ errors.cellphone }}
              </div>
            </div>



          </div>
          <div class="row mt-4">
            <div class="col-12 text-end ">

                <button 
                type="button"
                class="mb-0 me-2 ms-auto btn js-btn-next bg-gradient-secondary"
                title="Cancelar"
                @click="goBackPage"
                >
                  Cancelar
                </button>

                <button 
                type="submit"
                class="mb-0 ms-auto btn js-btn-next bg-gradient-dark"
                title="Crear usuario"
                >
                  Guardar
                </button>
            </div>
          </div>
      </div>
    </div>
    </form>

    <div class="row g-3"  v-show="isEdit && !isLoading">
      <div class="col-12 col-sm-4">
        <div class="mt-4 card card-body">
                    <div class="row text-center">
            <div class="col-12">
              <label>Imagen de perfil:</label>
            </div>
           <div class="col-12  mb-3">
                <img
                  class="mt-3 shadow-lg img-fluid border-radius-lg w-100 h-auto"
                  id="image-profile-view"
                  alt="profile-image"
                />
              </div>
          </div>   
        </div>
      </div>
      <div class="mx-auto col-sm-8 col-12">
        <div class="mt-4 card card-body">
          <h6 class="mb-0">Información básica</h6>
          <hr class="my-3 horizontal dark" />
          <div class="row">
            <div class="col-12 col-sm-6 col-lg-4 mb-3">
              <label>Nombre:</label>
              <input
                id="name"
                type="text"
                :value="user.name ? user.name : 'Sin nombre'"
                placeholder="eg. Michael"
                name="name"
                class="form-control"
                disabled
              />
            </div>
            <div class="col-12 col-sm-6 col-lg-4  mb-3">
              <label>Apellido Paterno:</label>
              <input
                id="lastname"
                type="text"
                placeholder="eg. Jackson"
                name="lastname"
                :value="user.lastname ? user.lastname : 'Sin apellido' "
                class="form-control"
              disabled
              />
            </div>
            <div class="col-12 col-sm-6 col-lg-4  mb-3">
              <label>Apellido Materno:</label>
              <input
                id="surname"
                type="text"
                placeholder="eg. Smith"
                name="surname"
                :value="user.surname ? user.surname : 'Sin apellido'"
                class="form-control"
                disabled
              />
            </div>

            <div class="col-12 col-sm-6 col-lg-4 mb-3">
              <label>Sexo:</label>
              <select
                id="sex-select"
                class="form-control"
                name="sex-select"
                :value="user.sex"
                disabled
              >
                <option value="" selected disabled>Selecciona una opción...</option>
                <option value="1" >Masculino</option>
                <option value="2">Femenino</option>
              </select>
            </div>

            <div class="col-12 col-sm-6 col-lg-4 mb-3">
              <label>Fecha de nacimiento:</label>
             <input
                id="birthday"
                :type="user.birthday ? 'date' : 'text'"
                name="birthday"
                :value="user.birthday ? user.birthday : 'Sin fecha' "
                class="form-control"
                disabled
              />
            </div>

            <div class="col-12 col-sm-6 col-lg-4 mb-3">
              <label>Estado de residencia:</label>
              <select
                id="state-select"
                class="form-control"
                name="state-select"
                :value="user.state"
                disabled
              >
                <option value="" selected disabled>Sin estado</option>
                <option v-for="({id, name}, index) in states" :key="index" :value="id" >{{name}}</option>
              </select>
            </div>

              <div class="col-12 col-sm-6 col-lg-4 mb-3">
              <label>Télefono:</label>
             <input
                id="cellphone"
                :type="user.cellphone ? 'number' : 'text'"
                placeholder="eg. 76568788787"
                name="cellphone"
                :value="user.cellphone ? user.cellphone : 'Sin télefono'"
                class="form-control"
                disabled
              />
            </div>

              <div class="col-12 col-sm-6 col-lg-4 mb-3">
                <label>Usuario:</label>
                <input
                  id="username"
                  type="text"
                  placeholder="eg. MichaelJack"
                  name="username"
                  :value="user.username"
                  class="form-control"
                  disabled
                />
              </div>

              <div class="col-12 col-sm-6 col-lg-4 mb-3">
              <label>Correo:</label>
              <input
                id="email"
                type="email"
                placeholder="eg. example@address.com"
                name="email"
                :value="user.email"
                class="form-control"
                disabled
              />
            </div>


          </div>

          <div class="row mt-3" v-show="isEdit">
            <div class="col-12 text-end">
                <button
                  class="btn bg-gradient-danger"
                  @click="editProfile"
                >
                  Editar
                </button>
            </div>
          </div>
      </div>
    </div>
    </div>

  </div>
</template>

<script>
import Quill from "quill";
import blobToBase64 from '../../../../kernel/translate/blobToBase64'
import userValidator from '../../../../kernel/validators/user.validator'
import listStates from '../../../../modules/state/use-cases/list.state'
import getProfile from '../../../../modules/users/use-cases/get.profile'
import Loader from '../../../../components/Loader.vue'
import storeSession from '../../../../kernel/store/store.session';
import updateProfile from '../../use-cases/update.profile'
import changeProfile from '../../use-cases/change.profile'
import moment from 'moment'
import Types from '../../../../kernel/translate/imageType'

export default {
  name: "Profile",
  components:{
    Loader
  },
  data() {
    return {
      showMenu: false,
      activeClass: "js-active position-relative",
      activeStep: 0,
      formSteps: 3,
      preview: "",
      states: [],
      user:{
        profile: "",
        name: "",
        lastname: "",
        surname: "",
        sex: "",
        birthday: "",
        cellphone: null,
        username: "",
        email: "",
        confirmEmail: "",
        state: "",

      },
      errors:{
        profile: "",
        name: "",
        lastname: "",
        surname: "",
        sex: "",
        birthday: "",
        cellphone: "",
        username: "",
        email: "",
        confirmEmail: "",
         state: "",
      },
      userOriginal: {},
      isLoading: false,
      isEdit: true,
      idUser: 0,
    };
  },

  async mounted() {
    let {identKey}  = storeSession.getDataSession()
    this.idUser = identKey;
    this.isLoading = true;
    await this.getProfile(identKey);
    this.isLoading = false;
    if (document.getElementById("edit-description")) {
      // eslint-disable-next-line no-unused-vars
      var quill = new Quill("#edit-description", {
        theme: "snow", // Specify theme in configuration
      });
    }
    await this.listStates();
  },
  methods: {
    editProfile(){
      this.isEdit = !this.isEdit;
    },
    nextStep() {
      if (this.activeStep < this.formSteps) {
        this.activeStep += 1;
      } else {
        this.activeStep -= 1;
      }
    },
    prevStep() {
      if (this.activeStep > 0) {
        this.activeStep -= 1;
      }
    },
    async listStates(){
      const response = {...await listStates()};
      const {error, data} = response;
      if(!error){
          const {result} = data
          this.states = result
      }else{
          this.$swal({
          icon: "error", 
          title: 'Ocurrió un error durante la consultar. Inténtalo de nuevo.',
          type: "basic",
        });
      }
    },
    async getProfile(id){
     const response = {...await getProfile(id)};
      const {error, data} = response;
        if(!error){
          const {result:{profile}} = data
          const {result} = data
          document.getElementById("image-profile-edit").src = `data:image/${Types.getTypeFromImage(profile)};base64,${profile}`;
          document.getElementById("image-profile-view").src = `data:image/${Types.getTypeFromImage(profile)};base64,${profile}`;

        this.user = {...result, cellphone: result.cellphone === 0 ? '' : result.cellphone};
          this.userOriginal = {...result}
      }else{
           this.$swal({
            icon: "error", 
            title: 'Ocurrió un error durante la consultar. Inténtalo de nuevo.',
            type: "basic",
          });
      }
    },
    openExplorer(){
      const input = document.getElementById("img-input")
      input.click()
    },
    async handleFileChange(e){
      const input = document.getElementById("img-input")
      const file = e.target.files[0];
      const isFile = userValidator.validateImage(file);
      if(isFile){
        this.errors.profile = isFile;
        input.value = null;
      }else{
        document.getElementById("image-profile-edit").src = await blobToBase64(file) 
        this.user.profile = document.getElementById('image-profile-edit').src.split('base64,')[1]
      }
      setTimeout(() => {
        this.errors.profile = null;
      }, 3000);
      
     
    },
    goBackPage(){
      this.editProfile()
      document.getElementById("image-profile-edit").src = `data:image/${Types.getTypeFromImage(this.userOriginal.profile)};base64,${this.userOriginal.profile}`;
      this.user = {...this.userOriginal}
    },
    async preUpdateUser(){
      let user  = { ...this.user} 
      this.errors.name = userValidator.validateName(user.name);
      this.errors.lastname = userValidator.validateLastname(user.lastname);
      this.errors.surname = userValidator.validateSurname(user.surname);
      this.errors.sex = userValidator.validateSex(user.sex);
      this.errors.birthday = userValidator.validateBirthday(user.birthday);
      this.errors.state = userValidator.validateState(user.state, this.states);
      this.errors.cellphone = userValidator.validateCellphone(user.cellphone);

      if(!this.errors.name && !this.errors.lastname && ! this.errors.surname &&
        !this.errors.sex && !this.errors.birthday && !this.errors.cellphone
         && !this.errors.state) {
         let payload = {
            id: this.idUser,
            person:{
              id: this.user.id,
              name: user.name,
              surname: `${user.lastname} ${user.surname === '' ? '': user.surname}`,
              cellphone: user.cellphone,
              birthDate: user.birthday ? moment(new Date(user.birthday)).format('YYYY-MM-DD') : null,
              sex: `${parseInt(user.sex) === 1 ? 'H' : parseInt(user.sex) === 2 ? 'M' : ''}`,
              state: user.state ? { id: parseInt(user.state)} : null
            }
         }
          this.$swal({
          title: "¿Estás seguro(a) de guardar los cambios?",
          text: "¡No podrás revertir esto.!",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Confirmar",
          customClass: {
            confirmButton: "btn bg-gradient-success",
            cancelButton: "btn bg-gradient-secondary",
          },
          buttonsStyling: false,
        }).then(async(result) => {
          if (result.isConfirmed) {
              this.isLoading = true;
              const response = await updateProfile(payload)
              const {message, error, data}  = response
                this.isLoading = false;
              if(!error){
                const {result:{text}} = data
                this.$swal({
                  icon: "success",
                  title: message,
                  text: text,
                  type: 'success-message',
                });
                this.errors = {}
                this.isEdit = true;
                await this.getProfile(this.idUser)
              }else{
                const {text} = data
                this.$swal({
                    icon: "error", 
                    title: message,
                    text: text,
                    type: "basic",
                  });
              }
          } else if (result.dismiss === this.$swal.DismissReason.cancel) {
            this.$swal.dismiss;
          }
        });

      }
    },
    saveImage(){
      let user = {
        profile: document.getElementById('image-profile-edit').src.split('base64,')[1],
        id: this.idUser
      }
       this.$swal({
          title: "¿Estás seguro(a) de guardar los cambios?",
          text: "¡No podrás revertir esto.!",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Confirmar",
          customClass: {
            confirmButton: "btn bg-gradient-success",
            cancelButton: "btn bg-gradient-secondary",
          },
          buttonsStyling: false,
        }).then(async(result) => {
          if (result.isConfirmed) {
              this.isLoading = true;
              const response = await changeProfile(user)
              const {message, error, data}  = response
                this.isLoading = false;
              if(!error){
                const {result:{text}} = data
                this.$swal({
                  icon: "success",
                  title: message,
                  text: text,
                  type: 'success-message',
                });
                this.errors = {}
                this.isEdit = true;
                await this.getProfile(this.idUser)
              }else{
                const {text} = data
                this.$swal({
                    icon: "error", 
                    title: message,
                    text: text,
                    type: "basic",
                  });
              }
          } else if (result.dismiss === this.$swal.DismissReason.cancel) {
            this.$swal.dismiss;
          }
        });
    },


      
  },
};
</script>
